import React, { useContext } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AuthContext } from "../../../context/AuthContext";

const ButtonPermission = ({ className, name, permission, onClick, disable }) => {
  const { isAllowed } = useContext(AuthContext);

  return isAllowed(permission) ? (
    <Button className={className} onClick={onClick} disabled={disable}>
      {name}
    </Button>
  ) : (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Acesso negado</Tooltip>}>
      <span className="d-inline-block">
        <Button style={{ pointerEvents: "none" }} className={className} disabled>
          {name}
        </Button>
      </span>
    </OverlayTrigger>
  );
};

export default ButtonPermission;
